module.exports = __webpack_public_path__ + "img/small.b3b77a8b.jpg";